var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "page-background",
      on: {
        click: function ($event) {
          _vm.showFilters = false
        },
      },
    },
    [
      _c(
        "v-row",
        { staticClass: "px-16 mb-12", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "page-header" }, [
                        _vm._v("Global System Settings"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-8" },
                [
                  _vm._l(_vm.availableTabs, function (tab) {
                    return _c(
                      "v-col",
                      {
                        key: tab,
                        staticClass: "settings-tab",
                        class: { active: _vm.currentTab == tab },
                        attrs: { cols: "auto" },
                        on: {
                          click: function ($event) {
                            return _vm.tabClicked(tab)
                          },
                        },
                      },
                      [_c("label", [_vm._v(_vm._s(tab))])]
                    )
                  }),
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    { attrs: { cols: "auto" } },
                    [
                      _vm.showClearButton
                        ? _c("smart-btn", {
                            staticClass: "fl mr-4",
                            attrs: {
                              label: "Clear",
                              icon: _vm.ic_times,
                              "icon-class": "mr-2",
                              "icon-position": "left",
                              ripple: false,
                              "icon-width": "10",
                              width: "120",
                              bg: "white",
                              border: "navy-blue",
                              font: "navy-blue",
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.clearFilters.apply(null, arguments)
                              },
                            },
                          })
                        : _vm._e(),
                      _c("smart-btn", {
                        staticClass: "fr",
                        attrs: {
                          label: "Filters",
                          icon: _vm.ic_filters,
                          ripple: false,
                          "icon-class": "mr-2",
                          "icon-position": "left",
                          "icon-width": "12",
                          chip: _vm.filtersCount,
                          bg: "white",
                          border: "navy-blue",
                          font: "navy-blue",
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.showHideFilters.apply(null, arguments)
                          },
                        },
                      }),
                      _vm.showFilters
                        ? _c(
                            "v-card",
                            {
                              staticClass: "br-10 setting-filters pb-2",
                              attrs: { ripple: false },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                            },
                            [
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _vm.showAccountSettings ||
                                      _vm.showUserSettings
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "mb-n2",
                                              attrs: { cols: "12" },
                                            },
                                            [
                                              _c("smart-text-field", {
                                                attrs: {
                                                  placeholder: "Client Name",
                                                },
                                                model: {
                                                  value: _vm.clientName,
                                                  callback: function ($$v) {
                                                    _vm.clientName = $$v
                                                  },
                                                  expression: "clientName",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.showAdminSettings
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "mb-n2",
                                              attrs: { cols: "12" },
                                            },
                                            [
                                              _c("smart-text-field", {
                                                attrs: { placeholder: "Login" },
                                                model: {
                                                  value: _vm.login,
                                                  callback: function ($$v) {
                                                    _vm.login = $$v
                                                  },
                                                  expression: "login",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.showUserSettings
                                        ? _c(
                                            "v-col",
                                            {
                                              staticClass: "mb-n2",
                                              attrs: { cols: "12" },
                                            },
                                            [
                                              _c("smart-text-field", {
                                                attrs: {
                                                  placeholder: "User Name",
                                                },
                                                model: {
                                                  value: _vm.userName,
                                                  callback: function ($$v) {
                                                    _vm.userName = $$v
                                                  },
                                                  expression: "userName",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("smart-text-field", {
                                            attrs: { placeholder: "Key" },
                                            model: {
                                              value: _vm.key,
                                              callback: function ($$v) {
                                                _vm.key = $$v
                                              },
                                              expression: "key",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "mt-n2",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c("smart-text-field", {
                                            attrs: { placeholder: "Value" },
                                            model: {
                                              value: _vm.value,
                                              callback: function ($$v) {
                                                _vm.value = $$v
                                              },
                                              expression: "value",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "mt-n2",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c("smart-text-field", {
                                            attrs: {
                                              placeholder: "Description",
                                            },
                                            model: {
                                              value: _vm.description,
                                              callback: function ($$v) {
                                                _vm.description = $$v
                                              },
                                              expression: "description",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pb-2",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _c("smart-btn", {
                                            staticClass: "fr",
                                            attrs: {
                                              label: "Hide",
                                              width: "90",
                                              bg: "white",
                                              border: "navy-blue",
                                              font: "navy-blue",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return _vm.showHideFilters.apply(
                                                  null,
                                                  arguments
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "v-row",
                { staticClass: "mt-6" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "settings-grid-wrapper pl-3 br-10" },
                        [
                          _c(
                            "v-card-text",
                            [
                              _vm.showGlobalSettings
                                ? _c("global-system-settings", {
                                    on: {
                                      showEditDialog: _vm.showEditDialog,
                                      showCopyDialog: _vm.showCopyDialog,
                                    },
                                  })
                                : _vm._e(),
                              _vm.showAccountSettings
                                ? _c("account-system-settings", {
                                    on: {
                                      showEditDialog: _vm.showEditDialog,
                                      showCopyDialog: _vm.showCopyDialog,
                                    },
                                  })
                                : _vm._e(),
                              _vm.showUserSettings
                                ? _c("user-system-settings", {
                                    on: {
                                      showEditDialog: _vm.showEditDialog,
                                      showCopyDialog: _vm.showCopyDialog,
                                    },
                                  })
                                : _vm._e(),
                              _vm.showAdminSettings
                                ? _c("admin-system-settings", {
                                    on: {
                                      showEditDialog: _vm.showEditDialog,
                                      showCopyDialog: _vm.showCopyDialog,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.showPaging
                ? _c(
                    "v-row",
                    { staticClass: "mt-6", attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "auto" } },
                        [
                          _c("v-pagination", {
                            key: _vm.pagingRenderIndex,
                            staticClass: "pl-3",
                            attrs: {
                              length: _vm.pagingLength,
                              "total-visible": 10,
                            },
                            on: { input: _vm.pageChange },
                            model: {
                              value: _vm.currentPage,
                              callback: function ($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-snackbar",
                {
                  staticClass: "smart-snackbar",
                  scopedSlots: _vm._u([
                    {
                      key: "action",
                      fn: function (ref) {
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._b(
                              {
                                attrs: { color: "#007BFF", text: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.snackbar = false
                                  },
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            [_vm._v(" Close ")]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.snackbar,
                    callback: function ($$v) {
                      _vm.snackbar = $$v
                    },
                    expression: "snackbar",
                  },
                },
                [
                  _c("img", {
                    staticClass: "success-icon",
                    attrs: { src: _vm.ic_green_success_checkmark },
                  }),
                  _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v("Loading Settings"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "546px" },
          model: {
            value: _vm.displayEditSettingPopup,
            callback: function ($$v) {
              _vm.displayEditSettingPopup = $$v
            },
            expression: "displayEditSettingPopup",
          },
        },
        [
          _c("edit-system-setting", {
            on: {
              close: function ($event) {
                _vm.displayEditSettingPopup = false
              },
              settingSaved: _vm.settingSaved,
            },
          }),
        ],
        1
      ),
      _vm.displayCopySettingPopup
        ? _c(
            "v-dialog",
            {
              attrs: { "max-width": "546px" },
              model: {
                value: _vm.displayCopySettingPopup,
                callback: function ($$v) {
                  _vm.displayCopySettingPopup = $$v
                },
                expression: "displayCopySettingPopup",
              },
            },
            [
              _c("copy-system-setting", {
                on: {
                  close: function ($event) {
                    _vm.displayCopySettingPopup = false
                  },
                  settingCopied: _vm.settingCopied,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }